export default {
  // Subscription page
  'subscription.title': 'Plans d\'Abonnement',
  'subscription.subtitle': 'Choisissez le plan d\'abonnement parfait pour améliorer votre expérience Pink Paradise',
  'subscription.why_subscribe': 'Pourquoi s\'abonner?',
  'subscription.why_description': 'S\'abonner à Pink Paradise débloque un monde de fonctionnalités exclusives et de contenu premium, améliorant votre expérience et vous donnant accès à nos escorts vérifiées.',
  'subscription.privacy_title': 'Confidentialité Améliorée',
  'subscription.privacy_description': 'Tous les abonnements incluent des fonctionnalités de confidentialité améliorées et de messagerie sécurisée.',
  'subscription.content_title': 'Contenu Exclusif',
  'subscription.content_description': 'Accédez à des photos privées, des vidéos et des services premium non visibles pour les utilisateurs gratuits.',
  'subscription.support_title': 'Support Prioritaire',
  'subscription.support_description': 'Les abonnés reçoivent un support client prioritaire et une assistance.',
  
  // Free plan
  'subscription.free.title': 'Gratuit',
  'subscription.free.price': '0€/mois',
  'subscription.free.description': 'Accès basique à la plateforme',
  'subscription.free.feature1': 'Vues de profil limitées',
  'subscription.free.feature2': 'Parcourir le contenu public',
  'subscription.free.feature3': 'Créer votre propre profil',
  'subscription.free.feature4': 'Pas de messagerie',
  'subscription.free.feature5': 'Pas d\'accès au contenu premium',
  'subscription.free.feature6': 'Pas de badge de vérification',
  'subscription.free.feature7': 'Pas de filtres de recherche avancés',
  
  // Teaser plan
  'subscription.teaser.title': 'Teaser',
  'subscription.teaser.price': '4,99€/mois',
  'subscription.teaser.description': 'Accès amélioré avec messagerie',
  'subscription.teaser.feature1': 'Vues de profil illimitées',
  'subscription.teaser.feature2': 'Message jusqu\'à 5 profils par jour',
  'subscription.teaser.feature3': 'Voir les tarifs et services',
  'subscription.teaser.feature4': 'Accès au contenu de base',
  'subscription.teaser.feature5': 'Voir les numéros de téléphone',
  'subscription.teaser.feature6': 'Filtres de recherche basiques',
  'subscription.teaser.feature7': 'Pas d\'accès aux médias privés',
  
  // Regular plan
  'subscription.regular.title': 'Standard',
  'subscription.regular.price': '19,99€/mois',
  'subscription.regular.description': 'Accès complet avec fonctionnalités premium',
  'subscription.regular.feature1': 'Messagerie illimitée',
  'subscription.regular.feature2': 'Accès complet aux profils',
  'subscription.regular.feature3': 'Voir et laisser des avis',
  'subscription.regular.feature4': 'Accès au contenu avancé',
  'subscription.regular.feature5': 'Support prioritaire',
  'subscription.regular.feature6': 'Filtres de recherche avancés',
  'subscription.regular.feature7': 'Accès aux médias privés',
  
  // VIP plan
  'subscription.vip.title': 'VIP',
  'subscription.vip.price': '100€/mois',
  'subscription.vip.description': 'Expérience élite avec avantages exclusifs',
  'subscription.vip.feature1': 'Tout dans le plan Regular',
  'subscription.vip.feature2': 'Badge de vérification VIP',
  'subscription.vip.feature3': 'Placement prioritaire dans la recherche',
  'subscription.vip.feature4': 'Accès au contenu exclusif',
  'subscription.vip.feature5': 'Support client VIP',
  'subscription.vip.feature6': 'Analytiques de profil',
  'subscription.vip.feature7': 'Abonnements exclusifs d\'escort',
  
  // Buttons and messages
  'subscription.current_plan': 'Plan Actuel',
  'subscription.free_cta': 'Plan Gratuit',
  'subscription.subscribe_cta': 'S\'abonner',
  'subscription.processing': 'Traitement...',
  'subscription.update_success': 'Abonnement Mis à Jour',
  'subscription.update_failed': 'Mise à Jour Échouée',
  'subscription.error_try_again': 'Veuillez réessayer plus tard.',
  'subscription.subscribed_to': 'Vous êtes maintenant abonné à {plan}',
  
  // New keys
  'subscription.subscribe_to': 'S\'abonner à',
  'subscription.thank_you': 'Merci pour votre abonnement!',
  'subscription.access_granted': 'Vous avez maintenant accès au contenu premium',
  'subscription.premium_description': 'Accédez à des photos exclusives, vidéos et services spéciaux',
  'subscription.monthly_subscription': 'Abonnement mensuel',
  'subscription.month': 'mois',
  'subscription.cancel_anytime': 'Annulez à tout moment, sans engagement',
  'subscription.feature_1_title': 'Photos et vidéos exclusives',
  'subscription.feature_1_description': 'Accédez à du contenu réservé aux abonnés',
  'subscription.feature_2_title': 'Secrets privés',
  'subscription.feature_2_description': 'Découvrez des détails intimes et des préférences personnelles',
  'subscription.feature_3_title': 'Services premium',
  'subscription.feature_3_description': 'Accédez à des services exclusifs non disponibles pour les autres',
  'subscription.terms_notice': 'En vous abonnant, vous acceptez nos conditions générales et notre politique de confidentialité',
  'subscription.cancel': 'Annuler',
  'subscription.continue': 'Continuer',
  'subscription.subscribe_for': 'S\'abonner pour',
  
  // Ajout des clés manquantes depuis les logs
  'subscription.plans.basic.title': 'Basique',
  'subscription.plans.basic.price': '4,99€/mois',
  'subscription.plans.basic.benefits.messaging': 'Messagerie limitée',
  'subscription.plans.basic.benefits.photos': 'Photos de base',
  'subscription.plans.premium.title': 'Premium',
  'subscription.plans.premium.price': '19,99€/mois',
  'subscription.plans.premium.benefits.messaging': 'Messagerie illimitée',
  'subscription.plans.premium.benefits.photos': 'Photos exclusives',
  'subscription.plans.premium.benefits.verified': 'Badge vérifié',
  'subscription.plans.premium.benefits.priority': 'Support prioritaire',
  'subscription.plans.vip.title': 'VIP',
  'subscription.plans.vip.price': '100€/mois',
  'subscription.plans.vip.benefits.messaging': 'Messagerie prioritaire',
  'subscription.plans.vip.benefits.photos': 'Photos et vidéos exclusives',
  'subscription.plans.vip.benefits.verified': 'Badge VIP',
  'subscription.plans.vip.benefits.priority': 'Visibilité maximale',
  'subscription.plans.vip.benefits.exclusive': 'Avantages exclusifs',
  'subscription.plans.vip.benefits.support': 'Support dédié',
  'subscription.unlock_content': 'Débloquer le contenu',
  'subscription.choose_plan': 'Choisir un plan',
  'subscription.select_plan': 'Sélectionner',
  'subscription.recommended': 'Recommandé'
};
